/* Clarelume — theme.js */
(function () {
  'use strict';
  var C = window.Clarelume || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    var fmt = C.moneyFormat || '{{amount_with_comma_separator}} €';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (key) {
      case 'amount': val = delim(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': val = delim(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = delim(cents, 2, ' ', ','); break;
      default: val = delim(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }
  C.formatMoney = formatMoney;

  /* ---------- Announcement ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    if (open) { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (close || (nav.classList.contains('is-open') && e.target.closest('[data-mobile-nav] a'))) {
      nav.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('[data-slide]', g);
    var thumbs = $$('[data-thumb]', g);
    function show(n) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === n); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.thumb, 10)); });
    });
    // Swipe on mobile
    var main = $('.gallery__main', g), x0 = null, cur = 0;
    if (!main || slides.length < 2) return;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (Math.abs(dx) > 40) show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      x0 = null;
    });
  });

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  var dOpts = { weekday: 'short', day: 'numeric', month: 'short' };
  var now = new Date();
  var dFrom = addBusinessDays(now, (C.delivery && C.delivery.min) || 5).toLocaleDateString('es-ES', dOpts);
  var dTo = addBusinessDays(now, (C.delivery && C.delivery.max) || 10).toLocaleDateString('es-ES', dOpts);
  $$('[data-delivery-from]').forEach(function (el) { el.textContent = dFrom; });
  $$('[data-delivery-to]').forEach(function (el) { el.textContent = dTo; });

  /* ---------- Cart API ---------- */
  function cartJSON() {
    return fetch((C.routes ? C.routes.cart : '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function cartAdd(id, qty, extra) {
    var items = [{ id: parseInt(id, 10), quantity: parseInt(qty, 10) || 1 }].concat(extra || []);
    return fetch((C.routes ? C.routes.cartAdd : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function cartChange(key, qty) {
    return fetch((C.routes ? C.routes.cartChange : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    if (!drawer) return;
    var body = $('[data-cart-body]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    if (!cart.items.length) {
      renderExtras(cart);
      body.innerHTML = '<div class="drawer__empty"><p>Tu carrito está vacío.</p><a href="' + (C.routes ? C.routes.root : '/') + '#comprar" class="btn btn--cta" data-cart-close>' + esc(C.emptyCta || 'Ver productos') + '</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    renderExtras(cart);
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '';
      return '<div class="line">' +
        '<div class="line__img">' + img + '</div>' +
        '<div><div class="line__title">' + esc(it.product_title) + '</div>' +
        (it.variant_title ? '<div class="line__variant">' + esc(it.variant_title) + '</div>' : '') +
        '<div class="line__qty"><button type="button" aria-label="Quitar uno" data-line-qty="' + it.key + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Añadir uno" data-line-qty="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
        '<div class="line__price">' + formatMoney(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') + '</div>' +
        '</div>';
    }).join('');
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    var disc = cart.total_discount || 0;
    var discRow = $('[data-cart-discount-row]', drawer);
    if (discRow) { discRow.hidden = disc <= 0; $('[data-cart-discount]', drawer).textContent = '−' + formatMoney(disc); }
  }
  // Free-shipping progress bar + one-click upsell
  function renderExtras(cart) {
    if (!drawer) return;
    var th = (C.freeShip || 0) * 100;
    var ship = $('[data-ship-bar]', drawer), row = $('[data-ship-row]', drawer);
    if (ship) {
      var left = th - cart.total_price;
      if (th > 0 && left > 0) {
        ship.classList.remove('is-done');
        $('[data-ship-text]', ship).innerHTML = 'Te faltan <strong>' + formatMoney(left) + '</strong> para el envío GRATIS';
        $('[data-ship-fill]', ship).style.width = Math.max(6, Math.round(cart.total_price / th * 100)) + '%';
      } else {
        ship.classList.add('is-done');
        $('[data-ship-text]', ship).innerHTML = '¡Tu pedido tiene envío <strong>GRATIS</strong>!';
        $('[data-ship-fill]', ship).style.width = '100%';
      }
    }
    if (row) {
      var free = th === 0 || cart.total_price >= th;
      row.innerHTML = free ? '<strong style="color:var(--c-success)">Gratis</strong>' : '<span class="muted">Se calcula al pagar</span>';
    }
    var up = $('[data-upsell]', drawer);
    if (up) {
      var vid = parseInt(up.dataset.variant, 10);
      var inCart = cart.items.some(function (it) { return it.variant_id === vid || it.product_id === parseInt(up.dataset.product, 10); });
      up.hidden = inCart || !cart.items.length;
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add]');
    if (!b) return;
    b.disabled = true; b.classList.add('is-loading');
    cartAdd(b.dataset.upsellAdd, 1).then(cartJSON).then(renderCart)
      .catch(function () {}).then(function () { b.disabled = false; b.classList.remove('is-loading'); });
  });

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = $('[data-cart-close]', drawer); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  C.openCart = function () { cartJSON().then(function (c) { renderCart(c); openDrawer(); }); };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      if (drawer) { e.preventDefault(); C.openCart(); }
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('.drawer__overlay')) closeDrawer();
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      q.disabled = true;
      cartChange(q.dataset.lineQty, parseInt(q.dataset.q, 10)).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Product: packs + add to cart ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var form = $('[data-product-form]', sec);
    if (!form) return;
    var packs = $$('[data-pack]', sec);
    var vInput = $('[data-variant-input]', form);
    var qInput = $('[data-qty-input]', form);
    var atc = $('[data-atc]', form);
    var atcLabel = $('[data-atc-label]', form);
    var baseLabel = atcLabel ? atcLabel.textContent : '';
    var nowEls = $$('[data-price-now]', sec), wasEls = $$('[data-price-was]', sec), saveEl = $('[data-price-save]', sec);

    function current() {
      return packs.filter(function (p) { return p.checked; })[0] || packs[0];
    }
    function update() {
      var p = current();
      packs.forEach(function (x) { x.closest('.bundle').classList.toggle('is-selected', x === p); });
      if (!p) return;
      var price = parseInt(p.dataset.price, 10), cmp = parseInt(p.dataset.compare, 10) || 0;
      nowEls.forEach(function (el) { el.textContent = formatMoney(price); });
      wasEls.forEach(function (el) { el.textContent = cmp > price ? formatMoney(cmp) : ''; });
      if (saveEl) {
        if (cmp > price) { saveEl.hidden = false; saveEl.textContent = 'Ahorras ' + formatMoney(cmp - price); }
        else saveEl.hidden = true;
      }
      if (vInput && p.dataset.variantId) vInput.value = p.dataset.variantId;
      if (qInput) qInput.value = p.dataset.qty;
      if (atc) {
        var ok = p.dataset.available !== 'false';
        var addonEl = $('[data-addon]', sec);
        var total = price + (addonEl && addonEl.checked ? parseInt(addonEl.dataset.addonPrice, 10) || 0 : 0);
        atc.disabled = !ok;
        if (atcLabel) atcLabel.textContent = ok ? baseLabel + ' · ' + formatMoney(total) : 'Agotado temporalmente';
      }
    }
    packs.forEach(function (p) { p.addEventListener('change', update); });
    var addonInput = $('[data-addon]', sec);
    if (addonInput) addonInput.addEventListener('change', function () { addonInput.closest('.addon').classList.toggle('is-on', addonInput.checked); update(); });
    var zoomBtn = $('[data-addon-zoom]', sec), modal = $('[data-addon-modal]', sec);
    if (zoomBtn && modal && modal.showModal) {
      zoomBtn.addEventListener('click', function () { modal.showModal(); });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-addon-close]')) modal.close(); });
    }

    // Color / size pickers: re-map every pack to the chosen variant
    var vmapEl = $('[data-vmap]', sec), vmap = null;
    if (vmapEl) { try { vmap = JSON.parse(vmapEl.textContent); } catch (e) { vmap = null; } }
    var optInputs = $$('[data-opt]', sec);
    function picked(kind) {
      var i = optInputs.filter(function (x) { return x.dataset.opt === kind && x.checked; })[0];
      return i ? i.value : '';
    }
    function applyOptions(fromColor) {
      if (!vmap) { update(); return; }
      var v = vmap[picked('color') + '|' + picked('size')];
      optInputs.forEach(function (i) { i.closest('.size-pill').classList.toggle('is-selected', i.checked); });
      var lbl = $('[data-opt-label="color"]', sec); if (lbl) lbl.textContent = picked('color');
      packs.forEach(function (p) {
        var b = p.closest('.bundle');
        if (!v) { p.dataset.available = 'false'; return; }
        var qty = parseInt(p.dataset.unitQty, 10) || 1, d = parseInt(p.dataset.discount, 10) || 0;
        var full = v.price * qty, price = full - Math.round(full * d / 100);
        var cmp = d > 0 ? full : (v.compare * qty > price ? v.compare * qty : 0);
        p.dataset.variantId = v.id; p.dataset.price = price; p.dataset.compare = cmp;
        p.dataset.qty = qty; p.dataset.available = String(v.available);
        var bp = $('[data-bp]', b), bw = $('[data-bw]', b), bu = $('[data-bu]', b);
        if (bp) bp.textContent = formatMoney(price);
        if (bw) { bw.hidden = !(cmp > price); bw.textContent = formatMoney(cmp); }
        if (bu) bu.textContent = formatMoney(Math.round(price / qty)) + ' / ud.';
      });
      if (v && fromColor && v.img > -1) { var t = $('[data-thumb="' + v.img + '"]', sec); if (t) t.click(); }
      update();
    }
    optInputs.forEach(function (i) { i.addEventListener('change', function () { applyOptions(i.dataset.opt === 'color'); }); });
    if (vmap) applyOptions(false); else update();

    var checkoutUrl = (C.routes ? C.routes.root : '/') + 'checkout';
    function add(direct) {
      var p = current();
      if (!p || !p.dataset.variantId) {
        alert('Vista previa: crea el producto en Shopify para activar la compra.');
        return Promise.resolve();
      }
      atc.classList.add('is-loading');
      var addonEl = $('[data-addon]', sec);
      var extra = addonEl && addonEl.checked ? [{ id: parseInt(addonEl.dataset.addon, 10), quantity: 1 }] : [];
      return cartAdd(p.dataset.variantId, p.dataset.qty, extra)
        .then(function () {
          if (direct) { window.location.href = checkoutUrl; return new Promise(function () {}); }
          return cartJSON();
        })
        .then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'No se pudo añadir al carrito. Inténtalo de nuevo.'); })
        .then(function () { atc.classList.remove('is-loading'); });
    }
    var isDirect = atc && atc.dataset.direct === 'true';
    form.addEventListener('submit', function (e) { e.preventDefault(); add(isDirect); });
    var addOnly = $('[data-add-only]', sec);
    if (addOnly) addOnly.addEventListener('click', function () { add(false); });

    // Sticky bar
    var sticky = $('[data-sticky-atc]', sec);
    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc');
      var footer = $('.footer');
      var atcVisible = true, footVisible = false;
      var refresh = function () {
        var show = !atcVisible && !footVisible && atc.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; refresh(); }).observe(atc);
      if (footer) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; refresh(); }).observe(footer);
      $('[data-sticky-buy]', sticky).addEventListener('click', function () { add(isDirect); });
    }
  });

  // Initial cart count
  if ($('[data-cart-count]')) cartJSON().then(function (c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.dataset.count = c.item_count; });
  }).catch(function () {});
})();
